/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55967492
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withNavigate from '~/hocs/withNavigate';
import any from 'ramda/src/any';
import concat from 'ramda/src/concat';
import clone from 'ramda/src/clone';
import equals from 'ramda/src/equals';
import filter from 'ramda/src/filter';
import length from 'ramda/src/length';
import isNil from 'ramda/src/isNil';
import isEmpty from 'ramda/src/isEmpty';
import values from 'ramda/src/values';
import { toast } from 'react-toastify';
import Button from '@components/@core/AnimatedButton';
import CareerCertificationHeader from '@components/CareerCertificationHeader';
import Dropdown from '@components/@core/Dropdown';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import * as ProgramsList from '@components/LibraryProgramsList';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Settings from '@components/@core/Settings';
import TrainingCourses from '~/views/Manage/Reports/TrainingCourses';
import { LibraryTypes } from '~/services/config';
import { TrainingTypes, Expirations } from './Config';

class Add extends Component {
    state = {
        title: '',
        description: '',
        level: 1,
        expiration: 0,
        certificateLink: '',
        iconLink: LibraryTypes['certifications'].icon,
        author_id: null,
        company: this.props.company,
        department_id: [],
        competency_id: [],
        category_id: [],
        programLevels: [
            {
                levelTitle: 'Level 1',
                certificate_pdf: '',
                icon_url: '',
                chronology_lock: false,
                time_lock: false,
                habits: [],
                quotas: [],
                courses: [],
                tracks: [],
                pdf: [],
                word: [],
                powerpoint: [],
            },
        ],
        quotaData: false,
        habitData: false,
        levelInd: 0,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { modalData } = nextProps;
        const { programLevels, levelInd } = prevState;
        const modules = clone(programLevels);
        if (modalData.after) {
            const { quotas, habits } = modalData.after;
            if (quotas) {
                if (!equals(quotas, modules[levelInd]['quotas'])) {
                    modules[levelInd]['quotas'] = concat(modules[levelInd]['quotas'], quotas);
                    return { programLevels: modules, quotaData: true };
                }
            }
            if (habits) {
                if (!equals(habits, modules[levelInd]['habits'])) {
                    modules[levelInd]['habits'] = concat(modules[levelInd]['habits'], habits);
                    return { programLevels: modules, habitData: true };
                }
            }
        }
        return null;
    }

    componentDidUpdate(prevState) {
        const { quotaData, habitData, levelInd } = this.state;
        if (quotaData && !prevState.quotaData) {
            this.handleAddModule('quotas', levelInd);
            this.setState({ quotaData: false });
        }
        if (habitData && !prevState.habitData) {
            this.handleAddModule('habits', levelInd);
            this.setState({ habitData: false });
        }
    }

    handleSelectTags = (key) => (tag) => {
        switch (key) {
            case 'author':
                this.setState({ author_id: tag[0] });
                break;
            case 'department':
                this.setState({ department_id: tag });
                break;
            case 'competency':
                this.setState({ competency_id: tag });
                break;
            case 'category':
                this.setState({ category_id: tag });
                break;
            default:
                break;
        }
    };

    handleSelectLevels = (e) => {
        const level = e[0];
        let programLevels = [];
        for (let i = 0; i < level; i++) {
            programLevels[i] = {
                levelTitle: '',
                certificate_pdf: '',
                icon_url: '',
                chronology_lock: false,
                time_lock: false,
                habits: [],
                quotas: [],
                courses: [],
                tracks: [],
                pdf: [],
                word: [],
                powerpoint: [],
            };
        }
        this.setState({ level, programLevels });
    };

    handleChangeLevel = (key, ind) => (e) => {
        const programLevels = clone(this.state.programLevels);
        programLevels[ind][key] = e;
        this.setState({ programLevels });
    };

    handleDrop = (type) => (e) => {
        if (type === 'icon') {
            this.setState({ iconLink: e });
        } else {
            this.setState({ certificateLink: e[0] });
        }
    };

    handleSelectModule = (ind) => (e) => {
        this.handleAddModule(e[0].name, ind)();
    };

    handleNewModule(type, ind) {
        const { programLevels } = this.state;
        let payload = {};
        if (type === 'quotas') {
            const modules = clone(programLevels);
            const quotas = modules[ind][type];
            payload = { type: 'Add New Quota', data: { after: { quotas } } };
        }
        if (type === 'habits') {
            const modules = clone(programLevels);
            const habits = modules[ind][type];
            payload = {
                type: 'Add New Habit',
                data: { before: null, after: { habits } },
            };
        }
        if (type === 'powerpoint') {
            payload = { type: 'Add Document', data: { before: { id: 0, name: 'Power Point' } } };
        }
        if (type === 'word') {
            payload = { type: 'Add Document', data: { before: { id: 1, name: 'Word' } } };
        }
        if (type === 'pdf') {
            payload = { type: 'Add Document', data: { before: { id: 2, name: 'PDF' } } };
        }
        if (type === 'courses' || type === 'tracks') {
            this.props.navigate(`/library/training/${type}/new`);
            return;
        }
        this.setState({ levelInd: ind });
        this.props.onModal(payload);
    }

    handleAddModule = (type, ind) => () => {
        const { programLevels } = this.state;
        this.props.onModal({
            type: 'Attach Library',
            data: {
                before: {
                    show: [type],
                    modules: [],
                },
                after: programLevels[ind][type],
            },
            callBack: {
                onAttach: (e) => {
                    const modules = clone(programLevels);
                    modules[ind][type] = concat(modules[ind][type], e.templates);
                    this.setState({ programLevels: modules });
                },
                onAdd: () => this.handleNewModule(type, ind),
            },
        });
    };

    handleChangeModules = (type, ind) => (list) => {
        const programLevels = clone(this.state.programLevels);
        if (type === 'trainings') {
            const courses = filter((e) => 1 === e.card_type_id, list);
            const tracks = filter((e) => isNil(e.card_type_id), list);
            programLevels[ind]['courses'] = courses;
            programLevels[ind]['tracks'] = tracks;
            this.setState({ programLevels });
        } else if (type === 'documents') {
            const pdf = filter((e) => 'PDF' === e.data.type, list);
            const word = filter((e) => 'Word' === e.data.type, list);
            const powerpoint = filter((e) => 'Power Point' === e.data.type, list);
            programLevels[ind]['pdf'] = pdf;
            programLevels[ind]['word'] = word;
            programLevels[ind]['powerpoint'] = powerpoint;
            this.setState({ programLevels });
        } else if (type === 'expiration') {
            programLevels[ind].expired_at = list[0];
            this.setState({ programLevels });
        } else {
            programLevels[ind][type] = list;
            this.setState({ programLevels });
        }
    };

    handleSave = (index, published) => () => {
        const { title, description, level, certificateLink, iconLink, programLevels, company, author_id, department_id, competency_id, category_id, levelInd } = this.state;

        const { quotas } = programLevels[0];
        if (published === 1 || '') {
            if (isEmpty(title) || isEmpty(description) || isEmpty(level) || isEmpty(quotas)) {
                toast.error('Please enter Title, Description and Quotas properly to publish Certificate.', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                return;
            }
        } else {
            if (isEmpty(title) || isEmpty(description)) {
                toast.error('Please enter Title and Description properly to publish a draft.', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                return;
            }
        }

        if (index < level - 1) {
            this.handleContentPagination(levelInd + 2);
            return;
        }

        let levels = {};
        let disabled = false;
        for (let i = 0; i < level; i++) {
            const quotas = programLevels[i].quotas.map((item) => {
                const { title, habits, tracks, courses, word, pdf, powerpoint } = programLevels[i];
                const total = length(quotas) + length(habits) + length(concat(tracks, courses)) + length(concat(concat(word, pdf), powerpoint));
                const quotaDisabled = any((sl) => 0 === sl.quota_target || isNil(sl.quota_target))(programLevels[i].quotas);
                disabled = isEmpty(title) || total === 0 || quotaDisabled;
                return {
                    quota_template_id: item.id,
                    quota_target: item.quota_target || 0,
                    quota_calculation: item.quota_calculation || 0,
                    span_months: item.span_months || 0,
                    minimum_months: item.minimum_months || 0,
                };
            });

            let day = [],
                week = [],
                month = [];
            programLevels[i].habits.map((item) => {
                if (item.data.schedule_interval === 'day') {
                    day.push(item.id);
                } else if (item.data.schedule_interval === 'week') {
                    week.push(item.id);
                } else {
                    month.push(item.id);
                }
            });

            const trainings = concat(programLevels[i].courses, programLevels[i].tracks).map((item) => {
                const type = item.card_type_id === 1 ? 'course' : 'track';
                return {
                    type,
                    item_id: item.id,
                };
            });

            levels[i + 1] = {
                title: programLevels[i].levelTitle,
                certificate_pdf: certificateLink,
                icon_url: iconLink === LibraryTypes['certifications'].icon ? null : iconLink,
                expired_at: programLevels[i].expired_at,
                quotas,
                habits: { day, week, month },
                trainings: {
                    items: trainings,
                    days_to_complete: '',
                },
                chronology_lock: programLevels[i].chronology_lock,
                time_lock: programLevels[i].time_lock,
            };
        }

        if (disabled) {
            toast.error('Please enter Calculation Months and Required fields in the Quotas.', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            return;
        }

        const program = {
            author_id,
            company_id: company.id,
            user_id: null,
            status: 0,
            designation: 1,
            title,
            level,
            data: {
                levels,
                description,
                category: category_id,
                competency: competency_id,
                department: department_id,
            },
            type: 2,
            published,
        };

        const payload = {
            type: 'certifications',
            data: {
                program,
            },
        };
        this.props.onSave(payload, iconLink === LibraryTypes['certifications'].icon ? null : iconLink, certificateLink);
    };

    handleContentPagination = (e) => {
        this.setState({ levelInd: e - 1 });
    };

    handleAddLevel = () => {
        let { programLevels, levelInd, level } = this.state;
        let _levels = clone(programLevels);
        _levels[levelInd + 1] = {
            levelTitle: `Level ${programLevels.length + 1}`,
            certificate_pdf: '',
            icon_url: '',
            chronology_lock: false,
            time_lock: false,
            habits: [],
            quotas: [],
            courses: [],
            tracks: [],
            pdf: [],
            word: [],
            powerpoint: [],
        };
        level = values(_levels).length;
        this.setState({ programLevels: _levels, levelInd: levelInd + 1, level });
    };

    handleLabelTitle = (title) => {
        const { programLevels, levelInd } = this.state;
        let _levels = clone(programLevels);
        _levels[levelInd].levelTitle = title;
        this.setState({ programLevels: _levels });
    };

    render() {
        const { tags } = this.props;
        const { authors, departments, competencies, categories } = tags;
        const { title, description, programLevels, levelInd } = this.state;
        const { quotas, tracks, courses } = programLevels[levelInd];
        const trainings = concat(tracks, courses);
        const isDisabled = title === '' || description === '';

        const settings = [
            { name: 'Author', id: null, options: authors, select: 'author' },
            { name: 'Departments', id: null, options: departments, select: 'department' },
            { name: 'Competencies', id: null, options: competencies, select: 'competency' },
            { name: 'Categories', id: null, options: categories, select: 'category' },
        ];

        return (
            <>
                <Filter back="all certifications" />
                <div className="lib-programs-certification">
                    <CareerCertificationHeader
                        program={this.state}
                        type="certifications"
                        changeTitle={(title) => this.setState({ title })}
                        changeDescription={(description) => this.setState({ description })}
                        editable
                    />

                    <div className="modules-contents mt-3">
                        <div key={`level-${levelInd + 1}`}>
                            <div className="d-flex">
                                <p className="d-flex-1 dsl-b22 bold">Requirements</p>
                            </div>
                            <ResponsiveTabs
                                className="mb-3"
                                active={`${levelInd}`}
                                data={programLevels?.map((level, index) => ({
                                    id: `${index}`,
                                    name: level?.levelTitle?.length > 15 ? `${level.levelTitle?.substring(0, 15)}...` : level?.levelTitle || 'NA',
                                }))}
                                onTab={(e) => this.setState({ levelInd: e.id })}
                            />
                            <div className="d-flex">
                                <Input title="Level Title" value={programLevels[levelInd].levelTitle} onChange={this.handleLabelTitle} />
                            </div>
                            <div className="required-field pt-4">
                                <p className="dsl-b18 text-500">Goals</p>
                                <ProgramsList.QuotaList modules={quotas} quotaOptions={this.props.quotaOptions} onChange={this.handleChangeModules('quotas', levelInd)} type="certification" />
                                <div className="d-h-end pt-4">
                                    <Button name="Attach Goal" type="low" onClick={this.handleAddModule('quotas', levelInd)} />
                                </div>
                            </div>
                            <div className="required-field">
                                <TrainingCourses data={trainings} isEditable onChange={this.handleChangeModules('trainings', levelInd)} />
                                <div className="d-h-end py-4">
                                    <Dropdown
                                        align="right"
                                        width="fit-content"
                                        caret="none"
                                        returnBy="data"
                                        placeholder="Attach Learning"
                                        className="add-training-dropdown"
                                        selectable={false}
                                        data={TrainingTypes}
                                        onChange={this.handleSelectModule(levelInd)}
                                    />
                                </div>
                            </div>
                            <div className="py-4">
                                <p className="dsl-b18 text-500">Expiration</p>
                                <Dropdown
                                    className="expiration-dropdown"
                                    align="right"
                                    title="Expires:"
                                    data={Expirations}
                                    getValue={(e) => e.name}
                                    value={programLevels[levelInd].expired_at}
                                    onChange={this.handleChangeModules('expiration', levelInd)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 d-h-end">
                        <Button name="Add Level" type="low" onClick={this.handleAddLevel} />
                    </div>
                    <Settings values={settings} isEditable expanded handleSelect={this.handleSelectTags} />
                    <div className="d-flex flex-column pt-3">
                        <div className="d-h-end mt-2">
                            <>
                                <Button className="btn-save me-3" name="Draft" disabled={isDisabled} type="low" onClick={this.handleSave(levelInd, 0)} />
                                <Button className="btn-save" name="Publish" disabled={isDisabled} onClick={this.handleSave(levelInd, 1)} />
                            </>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

Add.propTypes = {
    tags: PropTypes.shape({
        authors: PropTypes.array,
        departments: PropTypes.array,
        competencies: PropTypes.array,
        categories: PropTypes.array,
    }),
    company: PropTypes.shape({
        id: PropTypes.number,
    }),
    onSave: PropTypes.func,
    onModal: PropTypes.func,
};

Add.defaultProps = {
    tags: {
        authors: [],
        departments: [],
        competencies: [],
        categories: [],
    },
    company: {
        id: 0,
    },
    onSave: () => {},
    onModal: () => {},
};

export default withNavigate(Add);
